module.exports = __webpack_public_path__ + "img/woman-in-kitchen.aa2b107b.jpg";